export default __webpack_public_path__ + "static/media/Wolf's Belt of the Grasslands.1615ae14.jpg";